import React from "react";
import MasterLoader from "../icons/MasterLoader";

const GlobalLoadingSpinner = () => {
  return (
    <>
      {/* blur effect */}
      <div className="z-[9998] absolute inset-0 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in" />

      {/* centered spinner */}
      <div className="absolute inset-0 flex items-center justify-center z-[9999]">
        <MasterLoader />
      </div>
    </>
  );
};

export default GlobalLoadingSpinner;
